import React from 'react';
import Testimonials from './Testimonials';
import Newsletter from './Newsletter';
import { sectionConfig } from '../config/sections';

export default function VideoGallery() {
  return (
    <>
      {sectionConfig.featuredVideos === 1 && (
        <section className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-navy-900">FEATURED VIDEOS</h2>
              <p className="mt-4 text-lg text-gray-600">Explore my latest features and property tours</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                <div className="relative" style={{ paddingTop: '56.25%' }}>
                  <iframe
                    src="https://iframe.mediadelivery.net/embed/369615/2dfa67fa-a56c-40e6-87a6-71d4eb07e590?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                    loading="lazy"
                    style={{ border: 0, position: 'absolute', top: 0, height: '100%', width: '100%' }}
                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                    allowFullScreen
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-navy-900">The American Dream TV Show</h3>
                  <p className="text-gray-600 mt-1">
                    Watch my debut on this Emmy nominated show featuring exclusive insights from Tri-City Americans Head Coach Stu Barnes and NHL prospect Jordan Gavin.
                  </p>
                </div>
              </div>
              
              <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                <div className="relative" style={{ paddingTop: '56.25%' }}>
                  <iframe
                    src="https://iframe.mediadelivery.net/embed/369615/7683f46e-6ec8-4618-8f0f-c3ab54228f5a?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                    loading="lazy"
                    style={{ border: 0, position: 'absolute', top: 0, height: '100%', width: '100%' }}
                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                    allowFullScreen
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-navy-900">2529 W Klamath Ave</h3>
                  <p className="text-gray-600 mt-1">
                    Tour this beautiful Kennewick home - watch until the end for a surprise! 😉
                  </p>
                </div>
              </div>
              
              <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                <div className="relative" style={{ paddingTop: '56.25%' }}>
                  <iframe
                    src="https://iframe.mediadelivery.net/embed/369615/f5893b4b-e065-42d8-9eb1-efae73f4b79e?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                    loading="lazy"
                    style={{ border: 0, position: 'absolute', top: 0, height: '100%', width: '100%' }}
                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                    allowFullScreen
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-navy-900">3408 W 42nd Pl</h3>
                  <p className="text-gray-600 mt-1">
                    Explore this stunning $705,000 Kennewick home - MLS #275240
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                <div className="relative" style={{ paddingTop: '56.25%' }}>
                  <iframe
                    src="https://iframe.mediadelivery.net/embed/369615/b45b5f62-44e2-49cb-86f4-9bb7d47d1a80?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                    loading="lazy"
                    style={{ border: 0, position: 'absolute', top: 0, height: '100%', width: '100%' }}
                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                    allowFullScreen
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-navy-900">Spacious West Richland Gem</h3>
                  <p className="text-gray-600 mt-1">
                    4 Beds, 3 Baths | Large Deck & Modern Upgrades!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {sectionConfig.testimonials === 1 && <Testimonials />}
      {sectionConfig.newsletter === 1 && <Newsletter />}
    </>
  );
}